import { useMutation } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";

export const useDownloadMedicalExamControlsMutation = () => {
  return useMutation(MedicalExaminationService.downloadCompanyTable);
};
